import { NBSP } from 'shared/constants/symbols';
import first from './assets/first.png';
import second from './assets/second.png';

export const BLOCKS = [
  {
    id: 1,
    text: `Войдите в личный кабинет Циан или${NBSP}зарегистрируйтесь на${NBSP}этой странице`,
    image: first,
  },
  {
    id: 2,
    text: `Автоматически начислим 1 000 бонусов, если ранее у вас не${NBSP}было активных объявлений`,
    image: second,
  },
];
